import SkillGroupConstants from "../../../_shared/constants";

namespace SkillGroupParentGETConstants {
  export const DESCRIPTION_MAX_LENGTH = SkillGroupConstants.DESCRIPTION_MAX_LENGTH;
}
export default SkillGroupParentGETConstants;
